import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogHeaderModule } from 'src/app/angular-core/components/dialog-header/dialog-header.module';
import { InputModule } from 'src/app/angular-core/components/input/input.module';
import { CompanyFilterComponent } from './company-filter.component';
import { SearchBarModule } from 'src/app/angular-core/components/search-bar/search-bar.module';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BasicListModule } from 'src/app/angular-core/components/basic-list/basic-list.module';

@NgModule({
  declarations: [CompanyFilterComponent],
  imports: [
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    DragDropModule,
    MatListModule,
    SearchBarModule,
    TranslateModule,
    FormsModule,
    MatProgressSpinnerModule,
    DialogHeaderModule,
    InputModule,
    BasicListModule,
  ],
  exports: [CompanyFilterComponent]
})
export class CompanyFilterModule { }
